import {
    BoxProps, Center, Flex, Input, InputGroup, InputLeftElement, InputRightElement, ResponsiveValue
} from "@chakra-ui/react";
import {useRef, useState} from "react";
import SearchIcon from "./SearchIcon";
import { CloseIcon } from "@chakra-ui/icons";

interface Props {
  onFilterClick?: () => void;
  onSearch: (searchTerm: string) => void;
  borderRadius?: string;
  border?: string;
  placeholder?: string; // Custom placeholder text
  localSearch?: boolean; // Local search flag
  isEventHistory?: boolean;
  searchBarWidth?: ResponsiveValue<number | (string & {}) | "px"> | undefined;
}
function SearchBar(props: Props & BoxProps) {
    const debounceTimer = useRef<NodeJS.Timeout | undefined>();
    const [query, setQuery] = useState(""); // User input

    async function handleSearch(e: any) {
        const searchTerm = e.target.value;
        setQuery(searchTerm);
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = undefined;
        }
        if (searchTerm === "") {
            setQuery("");
            if (props.localSearch) {
                props.onSearch(searchTerm);
            }
            return;
        }
        debounceTimer.current = setTimeout(() => {
            props.onSearch(searchTerm);
        }, 500);
    }

    return <Flex alignItems="center" gap="12px" w="full">
            <InputGroup
                alignItems="center"
                maxW={props.searchBarWidth ?? { base: "100%", md: "85%", lg: "320px" }}
                borderRadius={props.borderRadius}
                border={props.border}
            >
                <InputLeftElement h="full">
                    <SearchIcon />
                </InputLeftElement>
                <Input
                    px="12px"
                    borderRadius="8px"
                    backgroundColor={props.bg ?? "white"}
                    height="48px"
                    outline="none"
                    type="text"
                    value={query}
                    placeholder={props.placeholder ?? "Search"}
                    border="none"
                    _placeholder={{ color: "dark.100" }}
                    color="dark.500"
                    focusBorderColor="primary.500"
                    onChange={handleSearch}
                />
                {query && (
					<InputRightElement h={{ base: "48px", md: "48px", lg: "48px" }}>
						<CloseIcon
							cursor="pointer"
							fontSize={14}
							onClick={() => {
                                props.onSearch('')
                                setQuery('')
                            }}
						/>
					</InputRightElement>
				)}
            </InputGroup>
            {props.onFilterClick && (
                <FilterButton onClick={props.onFilterClick} enabled={!!props.isEventHistory}/>
            )}
    </Flex>;
}

function FilterButton(props: {onClick: VoidFunction, enabled: boolean}) {
    const bg = props.enabled ? "primary.500" : "#F5F7F9";
    const color = props.enabled ? "white" : "primary.500";
    return <Center
        bg={bg}
        color={color}
        _hover={{cursor: "pointer"}}
        onClick={props.onClick}
        height="48px"
        width="48px"
        borderRadius="8px"
    >
        <svg width="24" height="24" aria-hidden="true">
            <use xlinkHref="#funnel" />
        </svg>
    </Center>;
}

export default SearchBar;
